import { Injectable, RendererFactory2, Renderer2, inject } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ListenDOMChange {
    private rendererFactory2 = inject(RendererFactory2);


    /** propiedad que es emitida cuando se modifica el 'resize' de la ventana - permite subscripcion  */
    isMobile: BehaviorSubject<boolean> = new BehaviorSubject( window.innerWidth <= 768 );

    /** Propiedad que contendra el renderizado personalizado del elemento DOM */
    renderer: Renderer2;

    constructor(){
        this.renderer = this.rendererFactory2.createRenderer( null, null );
        this.renderer.listen('window', 'resize', () => {
            this.isMobile.next( window.innerWidth <= 768 );
        });
    }

}